define('formkit/view/form.object/content/date.input.content.view',['require','exports','module','uikit/uikit','./base.input.content.view','../../../templates'],function(require, exports, module){
  var UIKit                = require('uikit/uikit');
  var BaseInputContentView = require('./base.input.content.view');
  var Templates            = require('../../../templates');


  var PreviewAnswerView = BaseInputContentView.PreviewAnswerView.extend({
    internalViewOptions: BaseInputContentView.PreviewAnswerView.extendInternalViewOptions({
      inputView: function() {
        return {
          type: UIKit.InputDate,
          fluid: true,
          fixed: true
        }
      }
    }),

    onInputViewInputFocus: function() {
      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form)
      });
    },

    onInputViewInputChangeValue: function() {
      if (!this.getOption('readonly')) {
        this.form.triggerEndEditAnswerEvent(this, this.model, {
          answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form)
        });
      }
    },

    onInputViewInputButtonPress: function() {
      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form)
      });
      this.form.triggerEndEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form)
      });
    }
  });


  var DateInputContentView = BaseInputContentView.extend({
    internalViewOptions: BaseInputContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView
        }
      }
    })
  });

  DateInputContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = DateInputContentView;
});

